import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star-2",
  "use": "star-2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star-2\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.4164 8.58359L10 4L8.58359 8.58359H4L7.7082 11.4164L6.2918 16L10 13.1672L13.7082 16L12.2918 11.4164L16 8.58359H11.4164ZM13.7415 9.35519H10.8833L10 6.49693L9.11675 9.35519H6.25849L8.57087 11.1217L7.68762 13.9799L10 12.2134L12.3124 13.9799L11.4291 11.1217L13.7415 9.35519Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol